'use strict';

const areIdenticalIntervals = (a, b) => a.start === b.start && a.end === b.end;

exports.areIdenticalIntervals = areIdenticalIntervals;
//# sourceMappingURL=areIdenticalIntervals.cjs.map
